/** Active session JWT (same as Strapi users-permissions login). */
export const STRAPI_JWT_STORAGE_KEY = 'strapi_jwt';

/** Admin JWT saved before impersonation; used to restore the original session. */
export const IMPERSONATE_STRAPI_JWT_STORAGE_KEY = 'impersonate_strapi_jwt';

export function readImpersonationBackupJwt(): string | null {
  return localStorage.getItem(IMPERSONATE_STRAPI_JWT_STORAGE_KEY);
}

export function isImpersonationActive(): boolean {
  return Boolean(readImpersonationBackupJwt());
}
